var y = Object.defineProperty;
var n = (i, t, e) => t in i ? y(i, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : i[t] = e;
var a = (i, t, e) => (n(i, typeof t != "symbol" ? t + "" : t, e), e);
import { differenceInCalendarDays as l, isBefore as h, dateFormat as c } from "@smh/utils/date-time";
const D = "jtnews", u = -1, o = -1, _ = -2, S = 7, d = 30, g = "_first_visit_date", V = "_loyalty_user", f = "_last_visit_date";
class T {
  constructor(t, e, s = D) {
    a(this, "_daysFromLastVisit", 0);
    a(this, "_loyalty", "Average");
    this._isUserRegion = t, this._date = e, this._prefix = s, this._init();
  }
  get firstVisitDateKey() {
    return `${this._prefix}${g}`;
  }
  get loyaltyUserKey() {
    return `${this._prefix}${V}`;
  }
  get lastVisitDateKey() {
    return `${this._prefix}${f}`;
  }
  get keys() {
    return {
      firstVisitDateKey: this.firstVisitDateKey,
      loyaltyUserKey: this.loyaltyUserKey,
      lastVisitDateKey: this.lastVisitDateKey
    };
  }
  get loyalty() {
    return this._loyalty;
  }
  get daysFromLastVisit() {
    return this._daysFromLastVisit;
  }
  _init() {
    this._getFirstVisitDate() === 0 && this._saveFirstVisitDate();
    const { lastVisitDate: e, loyalty: s } = this._getSavedLoyaltyData();
    this._saveDaysFromLastVisit(e), this._saveLoyaltyStatus(s), this._saveLoyaltyDataInLocalStorage();
  }
  _saveLoyaltyStatus(t) {
    const e = this._daysFromLastVisit === 0 || this._daysFromLastVisit === _;
    this._loyalty = e && t ? t : this._calculateLoyalty(t);
  }
  _saveDaysFromLastVisit(t) {
    const e = l(
      Date.parse(this._date),
      t
    ), s = h(t, Date.parse(this._date), "days"), r = s || e === 0 && !s ? e : _;
    this._daysFromLastVisit = t === o ? u : r;
  }
  _calculateLoyalty(t) {
    return this._daysFromLastVisit === u || this._daysFromLastVisit === _ ? this._isUserRegion ? "Average" : "Disloyal" : this._daysFromLastVisit <= S ? this._isUserRegion ? "Loyal" : "Average" : this._daysFromLastVisit > d ? this._isUserRegion ? "Average" : "Disloyal" : this._isUserRegion && t === "Loyal" ? "Loyal" : this._isUserRegion && t !== "Loyal" ? "Average" : !this._isUserRegion && t === "Disloyal" ? "Disloyal" : (!this._isUserRegion && t !== "Disloyal", "Average");
  }
  _saveLoyaltyDataInLocalStorage() {
    typeof window < "u" && (window.localStorage.setItem(this.loyaltyUserKey, this._loyalty), window.localStorage.setItem(
      this.lastVisitDateKey,
      Date.parse(this._date).toString()
    ));
  }
  _saveFirstVisitDate() {
    typeof window < "u" && window.localStorage.setItem(
      this.firstVisitDateKey,
      Date.parse(this._date).toString()
    );
  }
  _getSavedLoyaltyData() {
    if (typeof window < "u") {
      const t = window.localStorage.getItem(this.lastVisitDateKey), e = window.localStorage.getItem(this.loyaltyUserKey);
      return {
        lastVisitDate: Number(t) || o,
        loyalty: e || void 0
      };
    }
    return {
      lastVisitDate: o,
      loyalty: void 0
    };
  }
  _getFirstVisitDate() {
    if (typeof window < "u") {
      const t = window.localStorage.getItem(this.firstVisitDateKey);
      return Number(t);
    }
    return 0;
  }
}
const w = 30, L = "jtnews", A = "_page_views_loyalty_status", E = "_page_views_loyalty_data";
class p {
  constructor(t = L) {
    a(this, "_date", "");
    a(this, "_hasCheckedUserStatus", !1);
    a(this, "_userStatus", "new_user");
    a(this, "_savedPageViewsData", null);
    a(this, "_totalViews", 0);
    this._prefix = t;
  }
  get userStatusKey() {
    return `${this._prefix}${A}`;
  }
  get pageViewsDataKey() {
    return `${this._prefix}${E}`;
  }
  get keys() {
    return { userStatusKey: this.userStatusKey, pageViewsDataKey: this.pageViewsDataKey };
  }
  getPageViewsLoyalty(t) {
    this._initServiceData(t);
    const { loyalty: e, views: s } = this._calcPageViewsLoyalty();
    return this._setPageViewsData(this._savedPageViewsData), { loyalty: e, views: s };
  }
  _initServiceData(t) {
    this._date = t, this._hasCheckedUserStatus || this._updateUserStatus(), this._savedPageViewsData === null && (this._savedPageViewsData = this._getSavedPageViewsData());
  }
  _calcPageViewsLoyalty() {
    return this._totalViews = this._totalViews > 0 ? this._totalViews + 1 : this._calcTotalViews(this._savedPageViewsData), { loyalty: this._userStatus === "new_user" ? "\u041D\u043E\u0432\u044B\u0439" : this._calcLoyaltyStatus(this._totalViews), views: this._totalViews };
  }
  _updateUserStatus() {
    if (typeof window < "u") {
      const t = window.localStorage.getItem(this.userStatusKey);
      this._userStatus = t !== null ? "old_user" : "new_user", this._saveUserStatusInLocalStorage(this._userStatus), this._hasCheckedUserStatus = !0;
    }
  }
  _getSavedPageViewsData() {
    if (typeof window < "u") {
      const t = window.localStorage.getItem(this.pageViewsDataKey);
      return this._getValidatedPageViewsData(t);
    }
    return null;
  }
  _getValidatedPageViewsData(t) {
    let e = {};
    if (t !== null) {
      try {
        e = JSON.parse(t);
      } catch (s) {
        console.error(s);
      }
      for (const s in e) {
        const r = l(this._date, s);
        (r > w || Number.isNaN(r)) && delete e[s];
      }
    }
    return e;
  }
  _calcTotalViews(t) {
    let e = 1;
    return t !== null && Object.keys(t).forEach((s) => {
      e += t[s];
    }), e;
  }
  _calcLoyaltyStatus(t) {
    let e = "\u041D\u043E\u0432\u044B\u0439";
    return t >= 1 && t < 4 ? e = "\u0421\u043B\u0443\u0447\u0430\u0439\u043D\u044B\u0439" : t >= 4 && t < 11 ? e = "\u0420\u0435\u0434\u043A\u0438\u0439" : t >= 11 && t < 21 ? e = "\u0420\u0435\u0433\u0443\u043B\u044F\u0440\u043D\u044B\u0439" : t >= 21 && t < 51 ? e = "\u041F\u043E\u0441\u0442\u043E\u044F\u043D\u043D\u044B\u0439" : t >= 51 && t < 121 ? e = "\u041B\u043E\u044F\u043B\u044C\u043D\u044B\u0439" : t >= 121 && t < 251 ? e = "\u041E\u0447\u0435\u043D\u044C_\u043B\u043E\u044F\u043B\u044C\u043D\u044B\u0439" : t >= 251 && (e = "\u0421\u0432\u0435\u0440\u0445\u043B\u043E\u044F\u043B\u044C\u043D\u044B\u0439"), e;
  }
  _setPageViewsData(t) {
    const e = c(this._date, "YYYY-MM-DD");
    if (t !== null) {
      const s = t[e] || 0;
      t[e] = s + 1;
    }
    typeof window < "u" && window.localStorage.setItem(this.pageViewsDataKey, JSON.stringify(t));
  }
  _saveUserStatusInLocalStorage(t) {
    typeof window !== void 0 && window.localStorage.setItem(this.userStatusKey, t);
  }
}
export {
  T as LoyaltyService,
  p as PageViewsLoyaltyService
};
